// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
    padding: 24px;
    max-width: 600px;
    margin: 0 auto;
}

.settings-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 24px;
}

.settings-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.settings-select {
    width: 100%;
    padding: 10px 14px;
    border-radius: 6px;
    border: 1px solid #d1d5db;
    font-size: 14px;
    color: #374151;
}

.car-list-title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
}

.car-list {
    list-style: none;
    padding: 0;
}

.car-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    margin-bottom: 12px;
    background-color: #f9fafb;
}

.car-name {
    font-size: 15px;
    font-weight: 500;
}

.switch {
    position: relative;
    display: inline-block;
    width: 42px;
    height: 22px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #d1d5db;
    transition: 0.3s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
}

input:checked + .slider {
    background-color: #3b82f6;
}

input:checked + .slider:before {
    transform: translateX(20px);
}

.action-link {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    text-decoration: none;
    background-color: #f3f4f6;
    color: #111827;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.action-link:hover {
    background-color: #e5e7eb;
}



.logout-variant:hover {
    background-color: #fee2e2;
}
.header {
    display: flex;
    align-items: center;
    justify-content: space-between; /* Dashboard left, logout right */
    width: 100%;
    padding: 0.5rem 1rem;
    gap: 0.5rem;
}

.settings-link {
    display: flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
    color: inherit;
    font-weight: 500;
}

.logout-variant {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font: inherit;
    padding: 0.25rem 0.5rem;
    background-color: #fef2f2;
    border-color: #fca5a5;
    color: #991b1b;
}

.icon {
    margin-right: 6px;
    display: inline-block;
    vertical-align: middle;
}

.icon-small {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
}

`, "",{"version":3,"sources":["webpack://./src/css/Settings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAE,iCAAiC;IACjE,WAAW;IACX,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;AAC1B","sourcesContent":[".settings-container {\r\n    padding: 24px;\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.settings-title {\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.settings-label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: 500;\r\n}\r\n\r\n.settings-select {\r\n    width: 100%;\r\n    padding: 10px 14px;\r\n    border-radius: 6px;\r\n    border: 1px solid #d1d5db;\r\n    font-size: 14px;\r\n    color: #374151;\r\n}\r\n\r\n.car-list-title {\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.car-list {\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\n.car-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 12px 16px;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 6px;\r\n    margin-bottom: 12px;\r\n    background-color: #f9fafb;\r\n}\r\n\r\n.car-name {\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n}\r\n\r\n.switch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 42px;\r\n    height: 22px;\r\n}\r\n\r\n.switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #d1d5db;\r\n    transition: 0.3s;\r\n    border-radius: 34px;\r\n}\r\n\r\n.slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 16px;\r\n    width: 16px;\r\n    left: 3px;\r\n    bottom: 3px;\r\n    background-color: white;\r\n    transition: 0.3s;\r\n    border-radius: 50%;\r\n}\r\n\r\ninput:checked + .slider {\r\n    background-color: #3b82f6;\r\n}\r\n\r\ninput:checked + .slider:before {\r\n    transform: translateX(20px);\r\n}\r\n\r\n.action-link {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-size: 14px;\r\n    padding: 8px 16px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    text-decoration: none;\r\n    background-color: #f3f4f6;\r\n    color: #111827;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.action-link:hover {\r\n    background-color: #e5e7eb;\r\n}\r\n\r\n\r\n\r\n.logout-variant:hover {\r\n    background-color: #fee2e2;\r\n}\r\n.header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between; /* Dashboard left, logout right */\r\n    width: 100%;\r\n    padding: 0.5rem 1rem;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.settings-link {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    text-decoration: none;\r\n    color: inherit;\r\n    font-weight: 500;\r\n}\r\n\r\n.logout-variant {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    cursor: pointer;\r\n    font: inherit;\r\n    padding: 0.25rem 0.5rem;\r\n    background-color: #fef2f2;\r\n    border-color: #fca5a5;\r\n    color: #991b1b;\r\n}\r\n\r\n.icon {\r\n    margin-right: 6px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n.icon-small {\r\n    width: 16px;\r\n    height: 16px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
